var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronBack = function SvgChevronBack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13653_3393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.47998 8.48055C5.38618 8.38687 5.33343 8.25978 5.33331 8.12722V7.87389C5.33485 7.74161 5.38739 7.61503 5.47998 7.52055L8.90665 4.10055C8.96923 4.03745 9.05443 4.00195 9.14331 4.00195C9.23219 4.00195 9.31739 4.03745 9.37998 4.10055L9.85331 4.57389C9.91602 4.63533 9.95136 4.71943 9.95136 4.80722C9.95136 4.89501 9.91602 4.97911 9.85331 5.04055L6.88665 8.00055L9.85331 10.9606C9.91642 11.0231 9.95191 11.1083 9.95191 11.1972C9.95191 11.2861 9.91642 11.3713 9.85331 11.4339L9.37998 11.9006C9.31739 11.9637 9.23219 11.9992 9.14331 11.9992C9.05443 11.9992 8.96923 11.9637 8.90665 11.9006L5.47998 8.48055Z",
    fill: "black",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13653_3393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-back.c50900532eacffe24e3bbd9b597b4c83.svg";